import { useRef, useState, useEffect } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

export const OneLineText = ({
  text,
  className,
  displayTooltip = true,
}: {
  text: string;
  className?: string;
  displayTooltip?: boolean;
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const getNumberOfLinesFromText = (text: string, fontSize = 14, containerWidth = 525) => {
    const tempElement = document.createElement('div');
    tempElement.style.width = `${containerWidth}px`;
    tempElement.style.fontSize = `${fontSize}px`;
    tempElement.style.visibility = 'hidden';
    tempElement.style.whiteSpace = 'pre-wrap';
    tempElement.style.overflowWrap = 'break-word';
    document.body.appendChild(tempElement);
    tempElement.innerText = text;
    const textHeight = tempElement.clientHeight;
    const lineHeight = parseFloat(getComputedStyle(tempElement).lineHeight);
    const numberOfLines = Math.ceil(textHeight / lineHeight);
    document.body.removeChild(tempElement);
    return numberOfLines;
  };

  const checkOverflow = () => {
    if (textRef.current) {
      const containerWidth = textRef.current.clientWidth || 0;
      const numberOfLines = getNumberOfLinesFromText(text, 14, containerWidth);
      setIsOverflow(numberOfLines > 1);
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [text]);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            ref={textRef}
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            className={className}
          >
            {text}
          </span>
        </TooltipTrigger>
        {isOverflow && displayTooltip && (
          <TooltipContent align="start" className="max-w-[300px]">
            {text}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};
